const EASE_OUT = [0.23, 1, 0.32, 1] as const;

const PANE_SECONDS = 0.2;
const CARD_SECONDS = 0.18;
const FRAME_SECONDS = 0.32;

export { CARD_SECONDS, EASE_OUT, FRAME_SECONDS, PANE_SECONDS };
